import React from 'react';
import '../css/card.css';
import '../css/skills.css';
import Seo from './Seo';
// Importation des logos des langages
import htmlLogo from '../imgs/skills/html5.svg';
import cssLogo from '../imgs/skills/css3.svg';
import jsLogo from '../imgs/skills/javascript.svg';
import csharpLogo from '../imgs/skills/csharp.svg';
import javaLogo from '../imgs/skills/java.svg';
import sqlLogo from '../imgs/skills/microsoftsqlserver.svg';
import laCiteLogo from '../imgs/skills/lacite.png';

// Liste des diplômes
const programs = [
  { name: 'Computer Engineering Technology', type: 'Advanced College Diploma · 3 years' },
  { name: 'Computer Programming', type: 'College Diploma · 2 years' },
];

// Liste des langages, séparés par catégorie
const skillGroups = [
  {
    name: 'Front-end',
    skills: [
      { name: 'HTML', logo: htmlLogo },
      { name: 'CSS', logo: cssLogo },
      { name: 'JavaScript', logo: jsLogo },
    ],
  },
  {
    name: 'Back-end',
    skills: [
      { name: 'C#', logo: csharpLogo },
      { name: 'Java', logo: javaLogo },
      { name: 'SQL', logo: sqlLogo },
    ],
  },
];

function Skills() {
  return (
    <div className="card-page">
      <Seo
        title="Education & Skills"
        path="/skills"
        description="Nicolas Carriere holds an advanced diploma in Computer Engineering Technology and a diploma in Computer Programming from Collège La Cité. Skills: HTML, CSS, JavaScript, C#, Java, SQL."
      />
      <section className="card-section">
        <h1>Education</h1>
        <div className="card">
          <ul className="program-list">
            {programs.map((program) => (
              <li key={program.name} className="program">
                <img src={laCiteLogo} alt="Collège La Cité logo" className="school-logo" />
                <div>
                  <div className="program-name">{program.name}</div>
                  <div className="program-type">Collège La Cité · {program.type}</div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="card-section">
        <h1>Skills</h1>
        <div className="card">
          {skillGroups.map((group) => (
            <div key={group.name} className="skill-group">
              <h2>{group.name}</h2>
              <div className="skill-grid">
                {group.skills.map((skill) => (
                  <div key={skill.name} className="skill-tile">
                    <img src={skill.logo} alt={`${skill.name} logo`} />
                    <div className="skill-name">{skill.name}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Skills;
